import React, { Component } from "react";
import { connect } from "react-redux";
import { TransparentButton } from "../BookingPortal/components/Shared";
import { PersonalFormAnimation } from "../BookingPortal/components/Shared/Animation";
import * as FormFields from "./components/FormFields";
import AppointmentSummary from "./components/AppointmentSummary";
import BackButton from "./components/BackButton";
import VerificationDrawer from "./components/VerificationDrawer";
import { personalDetailSelector } from "./selectors";
import {
  updatePersonalDetail,
  showError,
  toggleVerifyDrawer,
  requestVerificationCode
} from "./actions";
import * as FORM_KEYS from "./consts/formKeys";
import { reloadSteps, goToPage } from "../BookingPortal/actions";

class ContactForm extends Component {
  getFieldProps = key => {
    return {
      fieldKey: key,
      value: this.props.personalDetail[key],
      errorText: this.props.personalDetail.errors[key],
      onChange: this.handleFieldChange,
      onError: this.handleError
    };
  };

  handleFieldChange = (prop, value) => {
    this.props.updatePersonalDetail(prop, value);
  };

  handleError = (prop, errorMessage) => {
    this.props.showError(prop, errorMessage);
  };

  handleBackClick = () => {
    this.props.reloadSteps();
    this.props.goToPage("booking");
  };

  handlePlaceBooking = () => {
    const {
      useRecaptcha,
      requestVerificationCode,
      toggleVerifyDrawer
    } = this.props;
    if (!useRecaptcha) {
      requestVerificationCode();
    } else {
      toggleVerifyDrawer(true);
    }
  };

  renderMembershipCard = () => {
    if (!this.props.showMembershipCardFields) return null;

    return (
      <div>
        <div className="col-sm-3">
          <FormFields.CardNumber
            {...this.getFieldProps(FORM_KEYS.CARD_NUMBER)}
          />
        </div>
        <div className="col-sm-3">
          <FormFields.CardPosition
            {...this.getFieldProps(FORM_KEYS.CARD_POSITION)}
          />
        </div>
      </div>
    );
  };

  renderHealthFund = () => {
    const { isMedibank, showMembershipCardFields } = this.props;
    if (!isMedibank) return null;

    return (
      <div className="row">
        <div className={`col-sm-${showMembershipCardFields ? "6" : "12"}`}>
          <FormFields.HealthFund
            {...this.getFieldProps(FORM_KEYS.HEALTH_FUND)}
            dataSource={this.props.healthFunds}
          />
        </div>
        {this.renderMembershipCard()}
      </div>
    );
  };

  render() {
    return (
      <div className="booking-portal-container">
        <AppointmentSummary />
        <PersonalFormAnimation>
          <div className="personal-detail-form-container">
            <div className="form-heading">Personal Details</div>
            <div className="personal-detail-form-wrap">
              <div className="row display-flex">
                <div className="col-sm-6 col-md-4">
                  <FormFields.FirstName
                    {...this.getFieldProps(FORM_KEYS.FIRST_NAME)}
                  />
                </div>
                <div className="col-sm-6 col-md-4">
                  <FormFields.LastName
                    {...this.getFieldProps(FORM_KEYS.LAST_NAME)}
                  />
                </div>
                <div className="col-sm-6 col-md-4">
                  <FormFields.DateOfBirth
                    {...this.getFieldProps(FORM_KEYS.DATE_OF_BIRTH)}
                  />
                </div>
              </div>

              {this.renderHealthFund()}
              <div className="row">
                <div className="col-sm-6">
                  <FormFields.Email
                    {...this.getFieldProps(FORM_KEYS.EMAIL)}
                    compareTo={
                      this.props.personalDetail[FORM_KEYS.CONFIRM_EMAIL]
                    }
                    compareToErrorText={
                      this.props.personalDetail.errors[FORM_KEYS.CONFIRM_EMAIL]
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <FormFields.ConfirmEmail
                    {...this.getFieldProps(FORM_KEYS.CONFIRM_EMAIL)}
                    compareTo={this.props.personalDetail[FORM_KEYS.EMAIL]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <FormFields.Mobile
                    {...this.getFieldProps(FORM_KEYS.MOBILE)}
                    mobileHintDescription={this.props.mobileHintDescription}
                  />
                </div>
                {this.props.isMedibank ? (
                  <div className="col-sm-12">
                    <FormFields.CustomFields
                      {...this.getFieldProps(FORM_KEYS.CUSTOM_FIELDS)}
                      customFields={this.props.customFields}
                    />
                  </div>
                ) : null}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <FormFields.Comments
                    {...this.getFieldProps(FORM_KEYS.COMMENTS)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <FormFields.ConfirmationPolicy
                    customerConfirmationPolicy={
                      this.props.customerConfirmationPolicy
                    }
                  />
                </div>
              </div>
              <div className="form-btn-container">
                <BackButton onClick={this.handleBackClick} />
                <TransparentButton
                  label={
                    this.props.requireWaitingList ? "Confirm" : "Place booking"
                  }
                  color="pink"
                  style={{ float: "right" }}
                  disabled={Object.keys(this.props.errors).length !== 0}
                  onClick={this.handlePlaceBooking}
                />
              </div>
            </div>
          </div>
        </PersonalFormAnimation>
        <VerificationDrawer />
      </div>
    );
  }
}

export default connect(personalDetailSelector, {
  updatePersonalDetail,
  showError,
  toggleVerifyDrawer,
  reloadSteps,
  goToPage,
  requestVerificationCode
})(ContactForm);



// WEBPACK FOOTER //
// ./src/modules/ContactForm/index.js